<div class="content">
  <div class="row">
    <div class="navBanner">
      <span class="flex">
        <a [routerLink]="''">
          <img class="navLogo" src="assets/images/logo/wa_logo_white_yellow.svg" />
        </a>
      </span>
      <span>
        <button mat-button (click)="closeDrawer()">
          <mat-icon svgIcon="feather:x" ></mat-icon>
        </button>
      </span>
    </div>
  </div>

  <div class="navCategory">
    <mat-accordion>
      @for (category of navItems; track category; let index = $index) {
        @if (category.links && category.links.length > 0) {
          <mat-expansion-panel
            (opened)="handlePanelOpen(index)"
            (closed)="handlePanelClose(index)"
            hideToggle
            >
            <mat-expansion-panel-header>
              <mat-panel-title>
                @if (expandedCategoryIndex != index) {
                  <mat-icon svgIcon="feather:plus"></mat-icon>
                }
                @if (expandedCategoryIndex == index) {
                  <mat-icon svgIcon="feather:minus"></mat-icon>
                }
                <span class="navHeaderTextStyling">
                  {{ category.name }}
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="navLinks">
              @for (link of category.links; track link) {
                <a (click)="navigateToPage(category.linkPrefix + link.urlSlug)">
                  {{ link.name }}
                </a>
              }
            </div>
          </mat-expansion-panel>
        } @else {
          <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header (click)="navigateToPage(category.url)">
              <mat-panel-title>
                <span class="singleNavLinkTextStyling">
                  {{ category.name }}
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        }
      }
    </mat-accordion>
  </div>

  <div class="messageBox">
    <h3>Managed Cellarage</h3>
    <p>
      Wine Ark offers Managed Cellarage to ensure that your wine collection is stored in optimal conditions.
    </p>
    <a class="learnMore" href="manage-cellarage-offering" target="_blank">Learn more</a>
  </div>

  <div class="socialMediaSection">
    <a href="https://twitter.com/wineark" target="_blank" aria-label="Twitter">
      <mat-icon svgIcon="feather:twitter"></mat-icon>
    </a>
    <a href="https://www.facebook.com/wineark" target="_blank" aria-label="Facebook">
      <mat-icon svgIcon="feather:facebook"></mat-icon>
    </a>
    <a href="https://www.instagram.com/wine_ark" target="_blank" aria-label="Instagram">
      <mat-icon svgIcon="feather:instagram"></mat-icon>
    </a>
  </div>
</div>